<template>
  <div
    v-loading="loading.fetch"
    class="layout-screen">
    <TheHeader />
    <el-container style="height: calc(100vh - 60px); border: 1px solid #eee;">
      <el-aside
        width="200px">
        <el-menu
          :unique-opened="true"
          default-active="CourseConfig"
          class="setting_menu"
          @select="changeComponent">
          <el-submenu index="1">
            <template slot="title">评价配置</template>
            <el-menu-item index="CourseConfig">星级评价</el-menu-item>
            <!--            <el-menu-item index="ReviewConfig">课后星级评价</el-menu-item>-->
            <el-menu-item index="LevelSloganConfig">星级标语</el-menu-item>
            <el-menu-item index="TeacherSloganConfig">老师评语</el-menu-item>
          </el-submenu>
          <!--          <el-submenu index="2">-->
          <!--            <template slot="title">学习维度配置</template>-->
          <!--            <el-menu-item index="CourseConfig">维度配置</el-menu-item>-->
          <!--          </el-submenu>-->
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <component
            :is="componentKey"
            class="component_item"/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import CourseConfig from "./components/evaluate/CourseConfig.vue";
import ReviewConfig from "./components/evaluate/ReviewConfig.vue";
import LevelSloganConfig from "./components/evaluate/LevelSloganConfig.vue";
import TeacherSloganConfig from "./components/evaluate/TeacherSloganConfig.vue";

export default {
  name: "SettingConfig",
  components: {
    CourseConfig,
    ReviewConfig,
    LevelSloganConfig,
    TeacherSloganConfig,
  },
  data() {
    return {
      loading: {
        fetch: false,
      },
      componentKey: "CourseConfig",
    };
  },
  methods: {
    changeComponent(key) {
      console.log(key);
      this.componentKey = key;
    },
  },
};
</script>

<style scoped>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
</style>
<style>
  .setting_menu{
    height: 100%;
    text-align: center;
  }
  .setting_menu .el-submenu__title{
    font-weight: bold;
    font-size: 16px;
  }
  .setting_menu .el-menu-item{
    padding-left: 60px !important;
  }
</style>
